import { logWrapper } from '../utils';
import jQuery from 'jquery';

function ddvPannerDirectiveFactory(runtimeConstant) {
  function link(scope) {
    scope.$watch('url', (value) => {
      if (!value) return;

      jQuery(document).ready((JJJ) => {
        const urls = value.split(';');
        lateloading(JJJ, urls);
      });
    });
  }

  function run() {
    return {
      restrict: 'A',
      scope: {
        url: '@ddvPanner',
      },
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const ddvPannerDirective = ['runtimeConstant', ddvPannerDirectiveFactory];
